import { ApiClient } from "./api-client";
import { AssociateWithCustomerParams, CustomerId, UserContext, UserContextId } from "./types";

export default class UserContextClient extends ApiClient {
    constructor({ baseURL, useEnv }: { baseURL?: string; useEnv?: boolean }) {
        super({
            baseURL,
            useEnv,
            apiPrefix: "user-context",
        });
    }

    async getById({ userContextId }: UserContextId): Promise<UserContext> {
        return super.makeGetRequest<UserContext>(`/${userContextId}`);
    }

    async getByCustomerId({ customerId }: CustomerId): Promise<UserContext & CustomerId> {
        return super.makeGetRequest<UserContext & CustomerId>(`?customerId=${customerId}`);
    }

    async associateWithCustomer({
        userContextId,
        customerId,
    }: AssociateWithCustomerParams): Promise<UserContext & CustomerId> {
        return super.makePostRequest<UserContext & CustomerId>(`/${userContextId}`, { customerId });
    }
}
